// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"facc7cb8","453":"1b16cd4c","455":"3a1fd2e8","977":"a810b37c"}[chunkId] + ".chunk.js";
};